import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { Route, selectRoute } from "src/config/routes";
import { useLocation } from "react-router-dom";
import { ASSEMBLY_STATE } from "src/stores/assemblies/AssemblyStore";
import styles from "./AssemblyLiveModeBanner.module.css";
import { useHistory } from "react-router-dom";
import { CustomerType } from "src/components/sidebar/Sidebar";

const AssemblyLiveModeBannerBase = () => {
    const { t } = useTranslation();
    const { assemblyStore, authStore, agendaitemStore, navStore } = useContext(RootStoreContext);
    const location = useLocation();
    const history = useHistory();

    const onClickStartLiveMode = useCallback(async () => {
        assemblyStore.updateAssemblyState(8, t("screens.assemblies.livemode.successfull_activate").toString());
        assemblyStore.setIsAttendanceLiveModeTabActive(true);
        agendaitemStore.setCurrentAgendaItem(undefined);

        history.push(
            selectRoute(Route.assemblyLiveMode, authStore.user?.role, {
                assemblyid: assemblyStore.currentAssembly?.id || ""
            })
        );
    }, [assemblyStore, t, authStore.user?.role, history, agendaitemStore]);

    const assemblyId = assemblyStore.currentAssembly?.id || "";
    const attendanceListRoute = Route.assemblyAttendanceList.replace(":assemblyid", assemblyId);
    const agendaPreviewRoute = Route.agendaPreview.replace(":assemblyid", assemblyId);

    const isCustomerTypeTest = navStore.customer.type === CustomerType.TEST;
    const isAssemblyStateLiveModeActive = assemblyStore.currentAssembly?.state === ASSEMBLY_STATE.LIVEMODE_ACTIVE;
    const isPathnameAttendanceListOrAgendaPreviewRoute =
        location.pathname.includes(attendanceListRoute) || location.pathname.includes(agendaPreviewRoute);

    const shouldRenderAssemblyLiveModeBanner =
        isCustomerTypeTest && !isAssemblyStateLiveModeActive && isPathnameAttendanceListOrAgendaPreviewRoute;

    if (!shouldRenderAssemblyLiveModeBanner) {
        return null;
    }

    return (
        <div className={`container-fluid ${styles.AssemblyLiveModeBanner}`}>
            <UI.Row>
                <UI.Col xl={10} sm={10} className="d-flex align-items-center mb-4 mb-lg-0">
                    <div className={styles.AssemblyLiveModeTitle}>{t("screens.assemblies.livemode.title")}</div>
                    <div className={styles.AssemblyLiveModeText}>{t("screens.assemblies.livemode.banner_text")}</div>
                </UI.Col>
                <UI.Col xl={2} sm={1} className="d-flex align-items-center justify-content-end">
                    <button onClick={onClickStartLiveMode} className={styles.AssemblyLiveModeButton}>
                        <div>{t("labels.start")}</div>
                        <UI.Icon icon={UI.SVGIcon.Vector} size={40} />
                    </button>
                </UI.Col>
            </UI.Row>
        </div>
    );
};

export const AssemblyLiveModeBanner = Sentry.withProfiler(observer(AssemblyLiveModeBannerBase));
